import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-23b378a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "CompanyInformation" }
const _hoisted_2 = {
  key: 0,
  class: "mb-6 CompanyInformation__problems"
}
const _hoisted_3 = { class: "problems__header" }
const _hoisted_4 = { class: "flex items-center text-red-400" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-triangle text-lg" }, null, -1))
const _hoisted_6 = { class: "font-semibold text-red-400 ml-3" }
const _hoisted_7 = { class: "problems__body" }
const _hoisted_8 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_9 = { class: "font-semibold" }
const _hoisted_10 = { class: "mb-3" }
const _hoisted_11 = { class: "font-semibold" }
const _hoisted_12 = { class: "mb-3" }
const _hoisted_13 = { class: "font-semibold" }
const _hoisted_14 = {
  key: 1,
  class: "CompanyInformation__header"
}
const _hoisted_15 = { class: "font-semibold" }
const _hoisted_16 = { class: "font-semibold text-sm" }
const _hoisted_17 = {
  key: 2,
  class: "CompanyInformation__body"
}
const _hoisted_18 = { class: "body__row" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "БИН", -1))
const _hoisted_20 = { class: "row__value" }
const _hoisted_21 = { class: "body__row" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Руководитель", -1))
const _hoisted_23 = { class: "row__value" }
const _hoisted_24 = { class: "body__row" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "ИИН Руководителя", -1))
const _hoisted_26 = { class: "row__value" }
const _hoisted_27 = { class: "body__row" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Дата регистрации", -1))
const _hoisted_29 = { class: "row__value" }
const _hoisted_30 = { class: "body__row" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Адрес", -1))
const _hoisted_32 = { class: "row__value" }
const _hoisted_33 = { class: "body__row" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "№ Като", -1))
const _hoisted_35 = { class: "row__value" }
const _hoisted_36 = { class: "body__row" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Наименование като", -1))
const _hoisted_38 = { class: "row__value" }
const _hoisted_39 = { class: "body__row" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "№ КРП", -1))
const _hoisted_41 = { class: "row__value" }
const _hoisted_42 = { class: "body__row" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Размер предприятия", -1))
const _hoisted_44 = { class: "row__value" }
const _hoisted_45 = { class: "body__row" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Основной ОКЭД", -1))
const _hoisted_47 = { class: "row__value" }
const _hoisted_48 = { class: "body__row" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Форма собственности", -1))
const _hoisted_50 = { class: "row__value" }
const _hoisted_51 = { class: "body__row" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Плательщик НДС", -1))
const _hoisted_53 = { class: "row__value" }
const _hoisted_54 = { class: "body__row" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Степень риска налогоплательщика", -1))
const _hoisted_56 = { class: "row__value" }
const _hoisted_57 = { class: "flex items-center justify-end mt-6" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times mr-2" }, null, -1))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.company && _ctx.isRenderProblems)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("span", _hoisted_6, "Имеются проблемы (" + _toDisplayString(_ctx.companyProblems.length +
                            _ctx.headProblems.length +
                            _ctx.headIlligationProblems.length) + ")", 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            (_ctx.company.financialProblems)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  (_ctx.company.financialProblems)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode("У компании имееются финансовые проблемы")
                      ], 64))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.companyProblems.length)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("p", _hoisted_9, "Проблемы предприятия (" + _toDisplayString(_ctx.companyProblems.length) + ")", 1),
                  _createElementVNode("ul", _hoisted_10, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.companyProblems, (company_problem, i) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: `CompanyProblem-${i}`
                      }, _toDisplayString(company_problem), 1))
                    }), 128))
                  ])
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.headProblems.length)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createElementVNode("p", _hoisted_11, "Проблемы руководителя (" + _toDisplayString(_ctx.headProblems.length) + ")", 1),
                  _createElementVNode("ul", _hoisted_12, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headProblems, (head_problem, i) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: `HeadProblem-${i}`
                      }, _toDisplayString(head_problem), 1))
                    }), 128))
                  ])
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.headIlligationProblems.length)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                  _createElementVNode("p", _hoisted_13, " Сведения по судебным разбирательствам руководителя (" + _toDisplayString(_ctx.headIlligationProblems.length) + ") ", 1),
                  _createElementVNode("ul", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headIlligationProblems, (head_illigation_problem, i) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: `HeadIlligationProblem-${i}`
                      }, _toDisplayString(head_illigation_problem), 1))
                    }), 128))
                  ])
                ], 64))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.company)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.company.nameRu), 1),
          _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.company.shortName), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.company)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.company.bin), 1)
          ]),
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.company.fullnameDirector), 1)
          ]),
          _createElementVNode("div", _hoisted_24, [
            _hoisted_25,
            _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.company.directorIin || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_27, [
            _hoisted_28,
            _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.company.dateRegistration), 1)
          ]),
          _createElementVNode("div", _hoisted_30, [
            _hoisted_31,
            _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.company.legalAddress), 1)
          ]),
          _createElementVNode("div", _hoisted_33, [
            _hoisted_34,
            _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.company.idKato), 1)
          ]),
          _createElementVNode("div", _hoisted_36, [
            _hoisted_37,
            _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.company.katoName), 1)
          ]),
          _createElementVNode("div", _hoisted_39, [
            _hoisted_40,
            _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.company.idKrp), 1)
          ]),
          _createElementVNode("div", _hoisted_42, [
            _hoisted_43,
            _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.company.krp), 1)
          ]),
          _createElementVNode("div", _hoisted_45, [
            _hoisted_46,
            _createElementVNode("span", _hoisted_47, _toDisplayString(_ctx.company.oked), 1)
          ]),
          _createElementVNode("div", _hoisted_48, [
            _hoisted_49,
            _createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.company.typeOfOwnership), 1)
          ]),
          _createElementVNode("div", _hoisted_51, [
            _hoisted_52,
            _createElementVNode("span", _hoisted_53, _toDisplayString(_ctx.company.isNdsPayer ? 'Да' : 'Нет'), 1)
          ]),
          _createElementVNode("div", _hoisted_54, [
            _hoisted_55,
            _createElementVNode("span", _hoisted_56, _toDisplayString(_ctx.company.companyRiskFactor.taxRiskDegree), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_57, [
      _createVNode(_component_the_button, {
        class: "red small mr-6",
        loading: _ctx.isDeclineLoading,
        disabled: !_ctx.isCanDecline || _ctx.isConfirmLoading,
        onClick: _ctx.onDecline
      }, {
        default: _withCtx(() => [
          _hoisted_58,
          _createTextVNode(" Отказать ")
        ]),
        _: 1
      }, 8, ["loading", "disabled", "onClick"]),
      _createVNode(_component_the_button, {
        class: "primary small",
        loading: _ctx.isConfirmLoading,
        disabled: !_ctx.isCanConfirm || _ctx.isDeclineLoading,
        onClick: _ctx.onConfirm
      }, {
        default: _withCtx(() => [
          _hoisted_59,
          _createTextVNode(" Разрешить ")
        ]),
        _: 1
      }, 8, ["loading", "disabled", "onClick"])
    ])
  ]))
}